/**
 * Action Buttons Component
 * Provides view, edit, copy, delete, and restore buttons for table rows
 */
import { Eye, Pencil, Copy, Trash2, RotateCcw } from 'lucide-react'
import type { JSX } from 'react'

interface ActionButtonsProps {
  onView?: () => void
  onEdit?: () => void
  onCopy?: () => void
  onDelete?: () => void
  onRestore?: () => void
}

export default function ActionButtons({ onView, onEdit, onCopy, onDelete, onRestore }: ActionButtonsProps): JSX.Element {
  return (
    <div className="flex items-center gap-1" style={{ flexWrap: 'nowrap' }}>
      {onView && (
        <button
          onClick={onView}
          className="h-7 w-7 flex items-center justify-center rounded-full border border-gray-100 text-gray-400 hover:border-transparent hover:text-white hover:bg-[#3454cf] transition-all shrink-0"
          title="View"
        >
          <Eye className="h-3.5 w-3.5" />
        </button>
      )}
      {onEdit && (
        <button
          onClick={onEdit}
          className="h-7 w-7 flex items-center justify-center rounded-full border border-gray-100 text-gray-400 hover:border-transparent hover:text-white hover:bg-[#3454cf] transition-all shrink-0"
          title="Edit"
        >
          <Pencil className="h-3.5 w-3.5" />
        </button>
      )}
      {onCopy && (
        <button
          onClick={onCopy}
          className="h-7 w-7 flex items-center justify-center rounded-full border border-gray-100 text-gray-400 hover:border-transparent hover:text-white hover:bg-[#3454cf] transition-all shrink-0"
          title="Copy"
        >
          <Copy className="h-3.5 w-3.5" />
        </button>
      )}
      {onDelete && (
        <button
          onClick={onDelete}
          className="h-7 w-7 flex items-center justify-center rounded-full border border-gray-100 text-gray-400 hover:border-transparent hover:text-white hover:bg-red-500 transition-all shrink-0"
          title="Delete"
        >
          <Trash2 className="h-3.5 w-3.5" />
        </button>
      )}
      {onRestore && (
        <button
          onClick={onRestore}
          className="h-7 w-7 flex items-center justify-center rounded-full border border-gray-100 text-gray-400 hover:border-transparent hover:text-white hover:bg-emerald-500 transition-all shrink-0"
          title="Restore"
        >
          <RotateCcw className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  )
}
